import {FC} from "react";
import {Divider, IconButton, Menu, Typography} from "@mui/material";
import {useTopBar} from "../../hooks/useTopBar";
import {
    UseManageWorkspacesAndOrganizations
} from "../../../../authWorkspacesCookies/workspaces/hooks/useManageWorkspacesAndOrganizations";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useHistory} from "react-router";
import {PATH_LOCAL_SETTINGS} from "../../../../../newShared/constants";
import colors from "../../../../../newShared/theme/colors";
import {MoreVert} from "@mui/icons-material";
import {AvatarMenuTitle} from "../avatarMenuTitle";
import {MenuItemHoverBlue} from "../styled";
import {useMedia} from "../../../../../newShared/hooks/useMedia";
import {CommonAvatar} from "../../../../../newShared/components/Basic/CommonAvatar";
import {getName} from "../../../../../newShared/utils/text";
import {ChangeLanguageDialog} from "../../../../../newShared/components/changeLanguageDialog/hook";
import {LanguageChangeDialog} from "../../../../../newShared/components/changeLanguageDialog";
import {MobileMenuDialog} from "../mobileMenuDialog";
import {useDispatch} from "react-redux";
import {ContactUsDialog} from "../../../../components/contactUs/contactUsDialog";
import {setContactUsDialogAction} from "../../../../components/contactUs/store/slice";

export const ThreeDotsTopBar: FC = () => {
    const {t} = useMainTranslation('', {keyPrefix: 'TopBar.threeDots'});
    const history = useHistory();
    const dispatch = useDispatch();
    const openContactUsDialog = () => {
        dispatch(setContactUsDialogAction({isOpen: true}))
        handleThreeDotsClose();
    }

    const {currData: {currentUser}, logout} = UseManageWorkspacesAndOrganizations();
    const {
        anchorThreeDotsEl, handleThreeDotsOpen, handleThreeDotsClose,
        // handleGoToMain,
        // handleGoToReports,
        // handleGoToDocs,
    } = useTopBar();
    const {isMobile} = useMedia();
    const {toggleVisibility, isOpen} = ChangeLanguageDialog();

    const handleSelect = (path: string) => {
        history.push(path);
        handleThreeDotsClose()
    }

    return currentUser ? (
        <>
            <IconButton
                onClick={handleThreeDotsOpen}
                size={"large"}
                sx={{color: Boolean(anchorThreeDotsEl) ? colors.primary.blue : colors.text.grey_dark}}
            >
                <MoreVert/>
            </IconButton>
            <Menu
                keepMounted
                elevation={1}
                anchorEl={anchorThreeDotsEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorThreeDotsEl) && !isMobile}
                onClose={handleThreeDotsClose}
                style={{top: '6px'}}
                MenuListProps={{sx: {py: '0'}}}
            >
                {/*<MenuItem onClick={handleGoToMain}>*/}
                {/*    {t('Go to Main app')}*/}
                {/*</MenuItem>*/}
                <AvatarMenuTitle name={getName(currentUser.firstName, currentUser.lastName)} email={currentUser.email} isDesktop={false} handleClose={handleThreeDotsClose}>
                    <CommonAvatar name={currentUser.firstName || currentUser.lastName ? getName(currentUser.firstName, currentUser.lastName) : currentUser.email}
                                  size={'d28'} style={{cursor: 'default'}}/>
                </AvatarMenuTitle>
                <Divider sx={{margin: '0 !important'}}/>
                {/*<MenuItemHoverBlue onClick={() => {handleOpenSelectWorkspaceDialog(); handleThreeDotsClose();}}>*/}
                {/*    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Change workspace')}</Typography>*/}
                {/*</MenuItemHoverBlue>*/}
                <MenuItemHoverBlue onClick={() => {handleSelect(PATH_LOCAL_SETTINGS)}}>
                    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Settings')}</Typography>
                </MenuItemHoverBlue>
                <MenuItemHoverBlue onClick={openContactUsDialog}>
                    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Contact us')}</Typography>
                </MenuItemHoverBlue>
                <MenuItemHoverBlue onClick={() => {toggleVisibility(true); handleThreeDotsClose()}}>
                    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Language')}</Typography>
                </MenuItemHoverBlue>

                <Divider sx={{margin: '0 !important'}}/>

                <MenuItemHoverBlue onClick={() => {handleThreeDotsClose(); logout()}}>
                    <Typography variant={'*bodyText2'} color={colors.text.dark}>{t('Logout')}</Typography>
                </MenuItemHoverBlue>
            </Menu>
            <LanguageChangeDialog isOpen={isOpen} handleClose={toggleVisibility}/>
            <MobileMenuDialog isOpen={Boolean(anchorThreeDotsEl) && isMobile} handleClose={handleThreeDotsClose}/>
            <ContactUsDialog />
        </>
    ) : null
}